import { IfObservable } from './IfObservable';
export var _if = IfObservable.create;
//# sourceMappingURL=if.js.map